<template>
  <div>
    <v-container>
      <v-row>
        <v-col lg="12" offset-lg="0" xl="8" offset-xl="2">
          <v-row>
            <PageTitle :title="label('jobCandidateComplete')"/>
          </v-row>
          <v-row class="mt-12">
            <v-col cols="6" offset="3">
              応募が完了いたしました。<br>
              企業からのメッセージをお待ちください。
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="text-align: center;">
              <v-btn class="mx-2" large @click="onClickJobTop()">求人一覧に戻る</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PageTitle from "../../atoms/PageTitle";
import ComponentMixin from "../../ComponentMixin";
import { mapGetters } from "vuex";
import ApiMixin from "../../../ApiMixin";

export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "page",
  name: "JobCandidateCompletePage",
  components: {
    PageTitle,
  },
  beforeMount() {
  },
  data () {
    return {
      tab: null
    }
  },
  computed: {
    ...mapGetters("client", ["jobs"]),
    lang() {
      return this.$i18n.locale
    }
  },
  methods: {
    onClickJobTop() {
      this.go(`/`);
    },
  },

};
</script>

<style scoped lang="sass">
</style>
